/* DDI reward tiers (F-20261103-09, BF26 Phase 2).
 * ONE engine for every spend-tier reward: free shipping, gift cards, free gifts.
 * Tiers come from window.DDI_TIERS_CFG (snippets/ddi-reward-tiers-cfg.liquid). Adding a tier = one
 * more entry there; every touchpoint below picks it up and drops it on its end date.
 *
 * Mounts (any number per page):
 *   [data-ddi-tiers="cart"]   milestone tracker (cart drawer + cart page). Reads data-cart-total,
 *                             which Krown re-renders after every add / qty change.
 *   [data-ddi-tiers="line"]   one line for the product page (pitch, or the gap once the cart has items)
 *   [data-ddi-tiers="strip"]  slim band for the sale page / homepage
 * The announcement bar adds its own message from DDITiersLive (sections/ddi-announce-bar.liquid).
 * ?ddi_tiers_preview=1 ignores the start/end dates for this browser session (review before launch).
 */
(function () {
  if (window.DDITiers) { window.DDITiers.refresh(); return; }
  var KEY = 'ddiTiersReached';

  function preview() { try { return sessionStorage.getItem('ddiTiersPreview') === '1'; } catch (e) { return false; } }
  function rate() { return (window.Shopify && Shopify.currency && Number(Shopify.currency.rate)) || 1; }

  /* LAUNCH GATE: window.DDITiersLive (snippets/ddi-reward-tiers-cfg.liquid) drops any tier before its
     starts date and from its ends date, using this browser's clock on every page view. */
  function live() {
    var list = window.DDITiersLive ? window.DDITiersLive() : [];
    return list.map(function (t) { var c = {}; for (var k in t) c[k] = t[k]; c.cents = Math.round(t.amount * 100 * rate()); return c; })
      .sort(function (a, b) { return a.cents - b.cents; });
  }

  function money(c) {
    var d = c / 100, s = d % 1 === 0 ? String(d) : d.toFixed(2);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function fill(str, gap) { return String(str || '').replace('{gap}', '<strong>' + money(gap) + '</strong>'); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }

  var ICONS = {
    truck: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v9H3zM14 9h4l3 3v3h-7z"/><circle cx="7" cy="17" r="1.7"/><circle cx="17.5" cy="17" r="1.7"/></svg>',
    gift: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3.5" y="9" width="17" height="11" rx="1"/><path d="M3.5 13h17M12 9v11M12 9c-1.5-3-5-4-5-1.5S10 9 12 9zm0 0c1.5-3 5-4 5-1.5S14 9 12 9z"/></svg>',
    tick: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>'
  };
  function card(t) {
    return '<span class="ddi-tiers__card" aria-hidden="true"><span>' + esc(t.card || '') + '</span></span>';
  }

  function state(total) {
    var tiers = live(), reached = [], next = null;
    tiers.forEach(function (t) { if (total >= t.cents) reached.push(t); else if (!next) next = t; });
    return { tiers: tiers, reached: reached, next: next, gap: next ? next.cents - total : 0, total: total };
  }

  /* Remember what this shopper has already unlocked, so the "unlocked" pop fires once per tier. */
  function newly(st) {
    var seen = {}, out = [];
    try { seen = JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) {}
    var first = !Object.keys(seen).length && !sessionStorage.getItem(KEY + 'Init');
    st.reached.forEach(function (t) { if (!seen[t.id]) { if (!first) out.push(t); seen[t.id] = 1; } });
    st.tiers.forEach(function (t) { if (seen[t.id] && st.total < t.cents) delete seen[t.id]; });
    try { sessionStorage.setItem(KEY, JSON.stringify(seen)); sessionStorage.setItem(KEY + 'Init', '1'); } catch (e) {}
    return out;
  }

  /* The cart tracker only takes over from the theme's own free-shipping bar while a SECOND tier is live
     (the gift card, a free gift...). With free shipping alone, the existing bar stays exactly as it is. */
  function oldBar(el, on) {
    var p = el.parentNode, sn = p && p.querySelector('shipping-notice');
    if (sn) sn.style.display = on ? 'none' : '';
  }
  function renderCart(el, st) {
    if (st.tiers.length < 2) { el.hidden = true; oldBar(el, false); return; }
    el.hidden = false; oldBar(el, true);
    var max = st.tiers[st.tiers.length - 1].cents;
    var pct = Math.max(0, Math.min(100, st.total * 100 / max));
    var all = !st.next, top = st.tiers[st.tiers.length - 1];
    var head = all ? esc(top.done) : fill(st.next.goal, st.gap);
    var pops = el.hasAttribute('data-ddi-nopop') ? [] : newly(st);
    var gift = st.reached.filter(function (t) { return t.note; }).pop();
    var h = '';
    if (pops.length) {
      var p = pops[pops.length - 1];
      h += '<div class="ddi-tiers__pop" role="status">' + (p.card ? card(p) : '<span class="ddi-tiers__pop-ico">' + ICONS[p.icon || 'gift'] + '</span>') +
        '<span><strong>' + esc(p.unlocked || p.done) + '</strong>' + (p.note ? '<br>' + esc(p.note) : '') + '</span></div>';
    }
    h += '<p class="ddi-tiers__head">' + head + '</p>';
    h += '<div class="ddi-tiers__track"><span class="ddi-tiers__fill" style="width:' + pct.toFixed(1) + '%"></span>';
    st.tiers.forEach(function (t) {
      var on = st.total >= t.cents, isNext = st.next && st.next.id === t.id;
      h += '<span class="ddi-tiers__node' + (on ? ' is-done' : '') + (isNext ? ' is-next' : '') + (pops.indexOf(t) > -1 ? ' is-pop' : '') +
        '" style="left:' + (t.cents * 100 / max).toFixed(1) + '%">' + (on ? ICONS.tick : '') + '</span>';
    });
    h += '</div><div class="ddi-tiers__labels">';
    st.tiers.forEach(function (t, i) {
      var on = st.total >= t.cents, l = t.cents * 100 / max;
      var cls = l > 92 ? ' is-end' : (l < 12 ? ' is-start' : '');
      h += '<span class="ddi-tiers__label' + cls + (on ? ' is-done' : '') + '" style="left:' + l.toFixed(1) + '%">' +
        '<span class="ddi-tiers__ico">' + ICONS[t.icon || 'gift'] + '</span>' + esc(t.label) +
        '<span class="ddi-tiers__amt">' + (on ? 'Unlocked' : money(t.cents)) + '</span></span>';
    });
    h += '</div>';
    if (gift && !pops.length) h += '<p class="ddi-tiers__note">' + esc(gift.note) + '</p>';
    el.classList.toggle('is-all', all);
    el.innerHTML = h;
    var pop = el.querySelector('.ddi-tiers__pop');
    if (pop) setTimeout(function () {
      pop.classList.add('is-out');
      setTimeout(function () {
        if (!pop.parentNode) return;
        if (gift) { var n = document.createElement('p'); n.className = 'ddi-tiers__note'; n.textContent = gift.note; el.appendChild(n); }
        pop.parentNode.removeChild(pop);
      }, 350);
    }, 6000);
  }

  function pitchTier(st) {
    var p = st.tiers.filter(function (t) { return t.pitch; });
    return p.filter(function (t) { return st.total < t.cents; })[0] || p[p.length - 1] || null;
  }
  function renderLine(el, st) {
    var t = pitchTier(st);
    if (!t) { el.hidden = true; return; }
    el.hidden = false;
    var txt = st.total >= t.cents ? esc(t.done) : (st.total > 0 ? fill(t.goal, t.cents - st.total) : esc(t.pitch));
    el.innerHTML = (t.card ? card(t) : '<span class="ddi-tiers__ico">' + ICONS[t.icon || 'gift'] + '</span>') + '<span class="ddi-tiers__txt">' + txt + '</span>';
  }
  function renderStrip(el, st) {
    var t = pitchTier(st);
    if (!t) { el.hidden = true; return; }
    el.hidden = false;
    var sub = st.total > 0 && st.total < t.cents ? fill(t.goal, t.cents - st.total) : (st.total >= t.cents ? esc(t.done) : esc(t.note || ''));
    el.innerHTML = '<div class="ddi-tiers__strip-in">' + card(t) + '<div class="ddi-tiers__strip-txt"><strong>' + esc(t.pitch) + '</strong><span>' + sub + '</span></div>' +
      (t.url ? '<a class="ddi-tiers__strip-cta" href="' + esc(t.url) + '">' + esc(t.cta || 'Shop the sale') + '</a>' : '') + '</div>';
  }

  var cartTotal = null;
  function totalFor(el) {
    var a = el.getAttribute('data-cart-total');
    if (a !== null && a !== '') return parseInt(a, 10) || 0;
    return cartTotal || 0;
  }
  function refresh() {
    // the drawer's server-rendered total is the freshest number after an add: share it with every mount
    var c = document.querySelector('[data-ddi-tiers="cart"][data-cart-total]');
    if (c) cartTotal = parseInt(c.getAttribute('data-cart-total'), 10) || 0;
    var mounts = document.querySelectorAll('[data-ddi-tiers]'), cartMoved = false;
    for (var i = 0; i < mounts.length; i++) {
      var el = mounts[i], kind = el.getAttribute('data-ddi-tiers');
      var tot = totalFor(el), sig = kind + ':' + tot + ':' + preview();
      if (el._ddiSig === sig) continue;
      el._ddiSig = sig;
      var st = state(tot);
      if (kind === 'cart') { renderCart(el, st); cartMoved = true; }
      else if (kind === 'line') renderLine(el, st);
      else if (kind === 'strip') renderStrip(el, st);
    }
    if (c) { var s = state(cartTotal); api.next = s.next; api.gap = s.gap; api.total = s.total; }
    if (cartMoved && window.ddiShipGoalApply) try { window.ddiShipGoalApply(); } catch (e) {}
  }
  function pull() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { cartTotal = c.total_price || 0; refresh(); }).catch(function () {});
  }

  var api = window.DDITiers = { refresh: refresh, pull: pull, state: state, live: live, money: money, next: null, gap: 0, total: 0 };
  refresh(); pull();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) {
      var t = ms[i].target;
      if (t.nodeType === 1 && t.closest && t.closest('[data-ddi-tiers]')) continue;
      refresh(); return;
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  ['cart:updated', 'theme:cart:updated', 'ajaxCart:updated', 'cart:refresh'].forEach(function (ev) { window.addEventListener(ev, pull); document.addEventListener(ev, pull); });
})();
